import React from 'react';
import 'stylesheets/admin.scss';
import styles from '../../views/admin/EditCollegeProfile/styles.module.scss';
import EventSubscriptions from '../../views/admin/EditCollegeProfile/endpoint-configurations/event-subscriptions';
import EndpointConfigurations from '../../views/admin/EditCollegeProfile/endpoint-configurations/endpoint-configurations';
import classnames from 'classnames';

interface Props {
  universityId: string;
}

export default function EndpointConfigurationsTab({universityId}: Props) {
  return (
    <div className={classnames('mt-40', styles.editCollegeProfile)}>
      <div className={styles.integrationContainer}>
        <div className={styles.sectionContainer}>
          {universityId && <EndpointConfigurations universityId={universityId} />}
        </div>
        <div className={styles.sectionContainer}>
          {universityId && <EventSubscriptions universityId={universityId} />}
        </div>
      </div>
    </div>
  );
}
